<div class="modal-header">
    <h4 class="modal-title">{{ 'copyPropertiesModal.title' | translate }}</h4>
</div>
<div class="modal-body pt-0">
    <div class="modal-body-inner pt-2">
        <div class="form-check">
            <input [disabled]="isCopyConnectionsDisabled" class="form-check-input p-0 me-1" type="checkbox" id="copy-connections" [(ngModel)]="copyConnections">
            <label class="form-check-label" for="copy-connections">{{ 'copyPropertiesModal.copy_connections' | translate }}</label>
        </div>
        <table class="table table-striped table-hover p-1">
            <thead>
                <tr class="col-12">
                    <th class="property-name col-3">{{'copyPropertiesModal.connection_target' | translate}}</th>
                    <th class="property-value col-3">
                        <div class="form-check">
                            <input #sources [disabled]="!copyConnections" class="form-check-input p-0 me-1" (click)="sourcesSelectionHandler(sources.checked)" type="checkbox" id="sources">
                            <label class="form-check-label" for="sources">{{'copyPropertiesModal.connection_source' | translate}}</label>
                        </div>
                    </th>
                    <th class="property-value col-2">
                        <div class="form-check">
                            <input #props [disabled]="!copyConnections" class="form-check-input p-0 me-1" [(ngModel)]="isPropertiesChecked" (click)="selectionHandler(true, props.checked)" type="checkbox" id="props">
                            <label class="form-check-label" tooltip [tooltipText]="'copyPropertiesModal.copy_properties_hint' | translate" for="props">{{ 'copyPropertiesModal.copy_properties_title' | translate }}</label>
                        </div>
                    </th>
                    <th class="property-value col-2">
                        <div class="form-check">
                            <input #attrs [disabled]="!copyConnections" class="form-check-input p-0 me-1" [(ngModel)]="isAttributesChecked" (click)="selectionHandler(true, attrs.checked, true)" type="checkbox" id="attrs">
                            <label class="form-check-label" tooltip [tooltipText]="'copyPropertiesModal.copy_attributes_hint' | translate" for="attrs">{{ 'copyPropertiesModal.copy_attributes_title' | translate }}</label>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-scrollbar [style.height.vh]="40" [visibility]="'hover'">
                    <ng-template ngFor let-targetConnection [ngForOf]="targetConnectionList" let-i="index">
                        <tr class="middle no-text-selection col-12">
                            <td class="col-3 py-3">
                                <span>{{ getConnectionName(targetConnection) }}</span>
                            </td>
                            <td class="col-3 py-2">
                                <div class="d-flex">
                                    <div class="form-check">
                                        <input class="form-check-input p-0 me-1"
                                               type="checkbox"
                                               #sourceCheckBox
                                               id="source_{{ targetConnection.connectionName }}"
                                               [checked]="targetConnection.sourceConnectionName"
                                               (change)="toggleSourceConnection(sourceCheckBox.checked, targetConnection)"
                                               [disabled]="!copyConnections">
                                        <label class="form-check-label" for="source_{{ targetConnection.connectionName }}"></label>
                                    </div>
                                    <select [disabled]="!copyConnections" class="form-control h-auto" #source
                                            (change)="setSourceConnectionName(source.value, targetConnection)"
                                            [(ngModel)]="targetConnection.sourceConnectionName">
                                        <option *ngFor="let sourceConnection of getSourceListForConnection(targetConnection)" [ngValue]="sourceConnection?.connectionName">
                                            {{ sourceConnection?.connectionName }}
                                        </option>
                                    </select>
                                </div>
                            </td>
                            <td class="col-2 py-2">
                                <div class="form-check">
                                    <input class="form-check-input p-0 me-1"
                                           type="checkbox"
                                           #prop
                                           id="prop_{{ targetConnection.connectionName }}"
                                           [checked]="targetConnection.copyProperties"
                                           (change)="selectionHandler(false, prop.checked, false, targetConnection.connectionName)"
                                           [disabled]="!targetConnection.sourceConnectionName || !copyConnections">
                                    <label class="form-check-label" for="prop_{{ targetConnection.connectionName }}"></label>
                                </div>
                            </td>
                            <td class="col-2 py-2">
                                <div class="form-check">
                                    <input class="form-check-input p-0 me-1"
                                           type="checkbox"
                                           #attr
                                           id="attr_{{ targetConnection.connectionName }}"
                                           [checked]="targetConnection.copyAttributes"
                                           (change)="selectionHandler(false, attr.checked, true, targetConnection.connectionName)"
                                           [disabled]="!targetConnection.sourceConnectionName || !copyConnections || targetConnection.isNewConnection">
                                    <label class="form-check-label" for="attr_{{ targetConnection.connectionName }}"></label>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </ng-scrollbar>
            </tbody>
        </table>
        <div class="form-check mt-1">
            <input class="form-check-input py-0 me-1" type="checkbox" id="copy-connection-props" [(ngModel)]="copyConnectionProperties">
            <label class="form-check-label" for="copy-connection-props">{{ 'copyPropertiesModal.copy_article_connection_props' | translate }}</label>
        </div>
        <div class="form-check mt-1">
            <input class="form-check-input p-0 me-1" type="checkbox" id="copy-behavior-props" [(ngModel)]="copyBehaviorProperties">
            <label class="form-check-label" for="copy-behavior-props">{{ 'copyPropertiesModal.copy_article_behavior_props' | translate }}</label>
        </div>
        <div class="form-check mt-1">
            <input class="form-check-input p-0 me-1" type="checkbox" id="copy-plausi-props" [(ngModel)]="copyPlausiProperties">
            <label class="form-check-label" for="copy-plausi-props">{{ 'copyPropertiesModal.copy_article_plausi_props' | translate }}</label>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary btn-cancel" (click)="close()">
        {{'global.label.cancel' | translate}}
    </button>
    <button [disabled]="!copyPlausiProperties && !copyBehaviorProperties && !copyConnectionProperties && !copyConnections" class="btn btn-primary" (click)="save()">
        {{'global.label.apply' | translate}}
    </button>
</div>
